import { CallDirection } from "@swivl-mono/types";
import { PiArrowDownLeftBold, PiArrowUpRightBold } from "react-icons/pi";

interface CallDirectionIconProps {
  direction: CallDirection;
  className?: string;
}

export function CallDirectionIcon({ direction, className = "h-4 w-4" }: CallDirectionIconProps): React.ReactElement {
  const isInbound = direction === CallDirection.INBOUND;
  const Icon = isInbound ? PiArrowDownLeftBold : PiArrowUpRightBold;
  const colorClass = isInbound ? "text-teal-800" : "text-purple-800";
  return <Icon className={`${colorClass} shrink-0 ${className}`} />;
}
